import { Injectable } from "@angular/core";
import { MapHelperService } from "../../../../services/map-helper.service";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { environment } from "../../../../environments/environment";
import { Subject, Subscription } from "rxjs";
import { LayerDTO } from "../models/LayerDTO";
import { EnumLayerTypes } from "../../shared/helpers/enums/EnumLayerTypes";
import { LocationCategoriesService } from "./LocationCategories.service";
import { LayerService } from "./Layers.service";
import { LocationsService } from "./Locations.service";
@Injectable({
  providedIn: "root",
})
export class PanelInternalLayerService {
  isExpandCollapseAnimating: boolean = false;

  dataGeoJson: any;
  configUrl: string;
  capas = new Array<LayerDTO>();
  capasPivote = new Array<LayerDTO>();

  private intersectedFeatures$: Subject<any> = new Subject<any>();
  private capas$: Subject<LayerDTO[]> = new Subject<LayerDTO[]>();
  isActiveLayer: boolean = false;
  activeLayer: LayerDTO = {name: "layer-locationsGeneral", checked: false, idLayerType: 1, isVisible: false, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false, isLoading: false, mapSourceId: ["layer-locationsGeneral"]};
  isFilterLayer: boolean = false;
  filterLayer: LayerDTO = {name: "filter-layer-locationsGeneral", checked: false, idLayerType: 1, isVisible: false, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false, isLoading: false, mapSourceId: ["filter-layer-locationsGeneral"]};

  geofenceLayer: LayerDTO = {name: "Geocercas", checked: null, idLayerType: 1, isVisible: null, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false, isLoading: false, mapSourceId: [""]};

  isInternalLayersExpanded: boolean = true;
  isVirtualLayersExpanded: boolean = true;
  
  suscription_GetLayerDataByNameGeoJSON: Subscription;

  constructor(
    private mapHelper: MapHelperService,
    private locationCategoriesService: LocationCategoriesService,
    private locationService: LocationsService,
    private layerService : LayerService
  ) {
    this.configUrl = environment.host;

  }
  
  getLayers(): any {
    return this.capas$.asObservable();
  }

  setGeofenceToggle(resp){
    this.capas$.next(resp);
  }

  //crea las capas del lado interno
  createMapLayer(layer : LayerDTO) {
    var existingLayer = this.mapHelper.GetLayerByName(layer.name + "-layer");
    if (existingLayer != null && existingLayer != undefined) 
      return;

    console.log("MapLayer", layer);

    switch (layer.idLayerType) {
      case EnumLayerTypes.Point:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          -2
        );
        this.mapHelper.AddLayerIcon(
          layer.name + "-layer",
          layer.name + "-source",
          layer.icon,
          this.mapHelper.generalMapIconSize
        );
        break;
      case EnumLayerTypes.Lines:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerLine(
          layer.name + "-layer",
          layer.name + "-source"
        );
        break;
      case EnumLayerTypes.Polygon:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerCustomizablePolygons(
          layer.name + "-layer",
          layer.name + "-source",
          0.4
        );
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          -4
        );
        break;
      case EnumLayerTypes.Geofence:
        var existingGeofenceLayer = this.mapHelper.GetLayerByName("geofences-layer");
        if (existingGeofenceLayer != null && existingGeofenceLayer != undefined)
          return;

        console.log("Updating*******************************LayerGeoJson", layer.name + "-highSource");
        this.mapHelper.AddSourceHighEmptyGeoJson(layer.name + "-highsource");
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerGeofencesPolygons(
          "geofences-layer",
          layer.name + "-source"
        );
        this.mapHelper.AddLayerGeofencesByStatus(
          "geofencesStatus-layer",
          layer.name + "-highsource"
        );
        this.mapHelper.AddLayerTextH3WithStatus(
          "GeofenceText-layer",
          layer.name + "-source",
          "Name"
        );
        break;
      case EnumLayerTypes.ClusterPoints:
        var existingClusterLayer = this.mapHelper.GetLayerByName(layer.name + "-layerCluster");
        if (existingClusterLayer != null && existingClusterLayer != undefined)
          return;

        this.mapHelper.AddSourceClusteredEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerCluster(
          layer.name + "-layerCluster",
          layer.name + "-source"
        );
        this.mapHelper.AddLayerClusterCount(
          layer.name + "-layerClusterCount",
          layer.name + "-source"
        );

        this.mapHelper.AddLayerUnclusteredPointsV2(
          layer.name + "-layer",
          layer.name + "-source",
          layer.icon,
          this.mapHelper.generalMapIconSize
        );

        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          -2
        );
        break;
      case EnumLayerTypes.PrecalculatedPolygon:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerCustomizablePolygons(
          layer.name + "-layer",
          layer.name + "-source",
          0.4,
          "#b59df8"
        );
        this.mapHelper.AddLayerLine( 
          layer.name + "-layer-line", 
          layer.name + "-source",
          "#6e3afc",
          3
        );
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          -4
        );
      default:
        break;
    }
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(layer: LayerDTO) {
    const filteredLayer = this.capas.find((value) => {
      return value.name == layer.name;
    });
    if (filteredLayer != undefined) {
      if (!filteredLayer.checked || filteredLayer.checked == null) {
        this.ActivateLayer(layer);
      } else {
        this.DeactivateLayer(layer);
      }
    }else{
      console.log("Undefined filteredSystemLayer");
    }
  }

  ActivateLayer(layer: LayerDTO) {
    const filteredLayer = this.capas.find((value) => {
      return value.name == layer.name;
    });
    
    console.log("ActivateSystemLayer capa", layer, this.capas, filteredLayer);
    if (filteredLayer != undefined && !filteredLayer.checked) {
        if (layer.categoryId != undefined && layer.categoryId != null) {
          console.log("Mostrar capa categoria", layer);
          this.setLayerLoading(layer, true);
          this.suscription_GetLayerDataByNameGeoJSON = this.locationService.GetLayerByIdLocationCategoryGeoJSON( layer.categoryId ).subscribe((data) => {
            console.log(layer);
            if (data.isSuccess) {
              if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
                this.mapHelper.UpdateLayerGeoJson(  layer.name + "-highsource", JSON.parse(data.result) );
                this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", JSON.parse(data.result) );
              } else {
                this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", JSON.parse(data.result) );
              }
              filteredLayer.checked = true;
              this.setLayerLoading(layer, false);

              this.setMaphelperActiveLayers();
              if (this.suscription_GetLayerDataByNameGeoJSON)
                this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
            }else{
              this.setLayerLoading(filteredLayer, false);
            }
          });
          
        }else{
          this.setLayerLoading(layer, true);
          let obj: any;
          this.suscription_GetLayerDataByNameGeoJSON = this.layerService.GetLayerDataByNameGeoJSON( layer.name, filteredLayer.atributeDisplay).subscribe((data) => {
            //verifica si el texto es un json minificado y obtiene el data
            let isMinifiedText = true;
            try{
              obj = JSON.parse(data.toString());
              console.log("GetLayerDataByNameGeoJSON", obj);
            }catch(e){
              console.log(e);
              isMinifiedText = false;
            }
            if(isMinifiedText){
              data = new EstatusJSON();
              data.result = obj.Result;
              data.isSuccess = obj.IsSuccess;
              data.errors = obj.Errors;
              data.message = obj.Message;
            }

            if (data.isSuccess && data.result != null && data.result != "") {
              console.log("FilteredLayer", filteredLayer);
              try{
                if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
                  var polygonCollection = JSON.parse(data.result);
                  console.log("Updating*******************************LayerGeoJson", layer.name + "-highSource", JSON.parse(data.result), polygonCollection);
                  if (polygonCollection != null && polygonCollection.features != null) {
                    var pointCollection = polygonCollection;
                    pointCollection.features = pointCollection.features.map((feature) => {
                      var centroid = this.mapHelper.getpolygonCentroid(feature);
                      centroid.properties = feature.properties;
                      return centroid;
                    });
                    console.log("Updating*******************************LayerGeoJson", layer.name + "-highSource", pointCollection);
                    
                    this.mapHelper.UpdateLayerGeoJson( layer.name + "-highsource", pointCollection );
                  }
                  // this.mapHelper.UpdateLayerGeoJson( layer.name + "-highsource", JSON.parse(data.result) );
                  this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", JSON.parse(data.result) );
                }else {
                  console.log("Updating*******************************LayerGeoJson", filteredLayer.name + "-source");
                  this.mapHelper.UpdateLayerGeoJson( filteredLayer.name + "-source", JSON.parse(data.result) );
                }
              }catch(e){
                console.log(e);
              }
              filteredLayer.isVisible = true;
              filteredLayer.checked = true;
              this.setLayerLoading(layer, false);
              this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
            }else{
              this.setLayerLoading(layer, false);
            }    
          });
          if (!this.suscription_GetLayerDataByNameGeoJSON)
            this.setLayerLoading(layer, false);
          
          this.setMaphelperActiveLayers();
        }

        
        setTimeout(() => {
          this.setLayerLoading(filteredLayer, false);
        }, 40000);
    }
  }

  DeactivateLayer(layer: LayerDTO) {
    if (this.suscription_GetLayerDataByNameGeoJSON) 
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
    console.log("Desactivar capa", layer);
    const filteredLayer = this.capas.find((value) => {
      return value.name == layer.name;
    });
    if (filteredLayer != undefined) {
      if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
        this.mapHelper.UpdateLayerGeoJson( layer.name + "-highsource", this.mapHelper.Empty_GeoJson );
        this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", this.mapHelper.Empty_GeoJson );
      } else {
        this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", this.mapHelper.Empty_GeoJson );
      }
      filteredLayer.isVisible = false;
      filteredLayer.checked = false;
      this.setLayerLoading(filteredLayer, false);
      if (this.suscription_GetLayerDataByNameGeoJSON)
        this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();

      this.setMaphelperActiveLayers();
    }
  }

  onToggleLayerActivos(activate: boolean) {
    if (!activate) {
      this.mapHelper.HideLayer("layer-locationsGeneral");
      this.mapHelper.HideLayer("cluster-count");
      this.mapHelper.HideLayer("clusters");
      this.mapHelper.HideLayer("layer-pinText");
      this.activeLayer.checked = false;
    }else{
      this.mapHelper.ShowLayer("layer-locationsGeneral");
      this.mapHelper.ShowLayer("cluster-count");
      this.mapHelper.ShowLayer("clusters");
      this.mapHelper.ShowLayer("layer-pinText");
      this.activeLayer.checked = true;
    }
    
    this.setMaphelperActiveLayers();
  }

  onToggleLayerFiltros( activate: boolean) {
    if (!activate) {
      this.mapHelper.HideLayer("filter-layer-locationsGeneral");
      this.mapHelper.HideLayer("filter-cluster-count");
      this.mapHelper.HideLayer("filter-clusters");
      this.mapHelper.HideLayer("filter-layer-pinText");
      this.filterLayer.checked = false;
    }else{
      this.mapHelper.ShowLayer("filter-layer-locationsGeneral");
      this.mapHelper.ShowLayer("filter-cluster-count");
      this.mapHelper.ShowLayer("filter-clusters");
      this.mapHelper.ShowLayer("filter-layer-pinText");
      this.filterLayer.checked = true;
    }
    
    this.setMaphelperActiveLayers();
  }

  DeactivateAllLayers(){
    this.capas.forEach((layer) => {
      this.DeactivateLayer(layer);
    });
  }

  GetSelectedLayers(){
    var capas = this.capas.filter((layer) => {
      return layer.checked;
    });
    // this.activeLayer.checked = this.isActiveLayer;
    // this.filterLayer.checked = this.isFilterLayer;
    capas.push(this.activeLayer);
    capas.push(this.filterLayer);
    return capas;
  }

  setMaphelperActiveLayers(){
    //capas fijas
    var activeLayers =  this.GetSelectedLayers();
    this.mapHelper.activeLayers = activeLayers;
  }

  setLayerLoading(layer: LayerDTO, isLoading: boolean) {
    const filteredLayer = this.capas.find((value) => {
      return value.name == layer.name;
    });
    if (filteredLayer != undefined) {
      filteredLayer.isLoading = isLoading;
      this.capas$.next(this.capas);
    }
  }

  clearCheckedLayers(){
    this.capasPivote = this.capas.filter((layer) => { return layer.checked});
    console.log("CapasPivote", this.capasPivote);
    this.capas.forEach((layer) => {
      this.DeactivateLayer(layer);
    });
  }

  reactivateClearedLayers(){
    console.log("reactivateClearedLayers pivote", this.capasPivote);
    if (this.capasPivote.length > 0) {
      this.capasPivote.forEach((layer) => {
        this.ActivateLayer(layer);
      });
    }
  }

}
